export default __webpack_public_path__ + "static/media/qr-logo.2e96ccc5.png";